import React, { useContext } from "react"
import Box from "@material-ui/core/Box"
import { useMachine } from "@xstate/react"
import Button from "@material-ui/core/Button"

// components
import Table from "pages/Settings/AccountManagement/Staff/tables/main"
import PageHeaderTitle from "components/PageHeaderTitle"
import WithHeader from "layout/WithHeader"
import WithTable from "layout/WithTable"
import AccountSettings from "pages/Settings/AccountManagement/Staff/components/AccountSettings"
import FormStaff from "pages/Settings/AccountManagement/Staff/components/Form"
import FormReset from "pages/Settings/AccountManagement/Staff/components/FormReset"
import PermissionMessage from "components/PermissionMessage"

/** Machine */
import { StaffMachine } from "machines/Settings/AccountManagement/Staff"

/** Context */
import {
  IconAdd,
  IconSettings,
  IconSettingsDisabled
} from "components/Icons/Settings/AccountManagement"
import { AppContext } from "App"
import withContext from "./withContext"
import { CtxType } from "./Context"

/** Icons */

const SettingsStaffView: React.FC<CtxType> = ({ showFormType, activeData }) => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const { permission } = useContext(AppContext)
  const hasPermission = permission && Object.keys(permission).length !== 0

  const [current, send] = useMachine(StaffMachine)
  const xValue = current?.value

  /** Views */
  function ViewTitleArea(): JSX.Element {
    return (
      <>
        <Box>
          <PageHeaderTitle
            title="Staff Account Management"
            breadcrumbs="SETTINGS / account management / staff"
          />
        </Box>

        <Box display="flex" justifyContent="flex-end">
          <Box display="flex">
            <Box marginRight="15px">
              <Button
                color="primary"
                startIcon={
                  !permission?.account_settings ? IconSettingsDisabled : IconSettings
                }
                onClick={() => send("ACCOUNT_SETTINGS")}
                disabled={!permission?.account_settings}
              >
                STAFF ACCOUNT SETTINGS
              </Button>
            </Box>
          </Box>

          <Box display="flex">
            <Box marginRight="15px">
              <Button
                color="primary"
                startIcon={IconAdd}
                onClick={() => showFormType(true, 1)}
                variant="contained"
                disabled={!permission?.account_management}
              >
                ADD STAFF
              </Button>
            </Box>
          </Box>
        </Box>
      </>
    )
  }

  function ViewTable(): JSX.Element {
    if (xValue !== "tableView") {
      return <div />
    }
    return (
      <>
        <Box display="flex" justifyContent="space-between">
          <ViewTitleArea />
        </Box>
        <WithTable>
          <Table />
        </WithTable>
      </>
    )
  }

  function ViewSettings(): JSX.Element {
    if (xValue !== "accountSettings") {
      return <div />
    }
    return (
      <>
        <AccountSettings sendBack={() => send("TABLE_VIEW")} />
      </>
    )
  }

  function ViewForm(): JSX.Element {
    return <FormStaff data={activeData} />
  }

  function ViewFormReset(): JSX.Element {
    return <FormReset />
  }

  const MainView = (): JSX.Element => {
    return (
      <WithHeader>
        {ViewTable()}
        {ViewSettings()}
      </WithHeader>
    )
  }

  if (!hasPermission) {
    return <div />
  }

  if (permission?.account_management) {
    return (
      <>
        {MainView()}
        {ViewForm()}
        {ViewFormReset()}
      </>
    )
  }

  return (
    <WithHeader>
      <WithTable>
        <PermissionMessage />
      </WithTable>
    </WithHeader>
  )
}

export default withContext(SettingsStaffView)
